import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import type { AIInteractionItem } from '@/types/seeds';
import { formatDateTime } from '@/lib/utils';

interface AIInteractionsTableProps {
  interactions: AIInteractionItem[];
}

export function AIInteractionsTable({ interactions }: AIInteractionsTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>User</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Model</TableHead>
            <TableHead>Tokens</TableHead>
            <TableHead>Cost</TableHead>
            <TableHead>Time</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Date</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {interactions.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className="text-center text-muted-foreground">
                No AI interactions found.
              </TableCell>
            </TableRow>
          ) : (
            interactions.map((a) => (
              <TableRow key={a.id}>
                <TableCell className="font-medium">{a.student_name}</TableCell>
                <TableCell>
                  <Badge variant="outline">{a.interaction_type}</Badge>
                </TableCell>
                <TableCell className="text-muted-foreground">{a.model}</TableCell>
                <TableCell>{a.tokens_used.toLocaleString()}</TableCell>
                <TableCell>${(a.cost_cents / 100).toFixed(3)}</TableCell>
                <TableCell>{a.response_time_ms}ms</TableCell>
                <TableCell>
                  <Badge variant={a.success ? 'default' : 'destructive'}>
                    {a.success ? 'OK' : 'Error'}
                  </Badge>
                </TableCell>
                <TableCell>{formatDateTime(a.created_at)}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
